import React, { useEffect, useState } from 'react';
import { Translate } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities, updateEntity, restoreDefault } from './tire-alert-setting.reducer';
import { ITireAlertSetting } from 'app/shared/model/tire-alert-setting.model';
import { Box, Grid, Card, CardContent, Typography, TextField, Stack, useTheme, Button } from '@mui/material';

type TireAlertSettingWithError = ITireAlertSetting & { error?: string | null; };

export const TireAlertSetting = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const tireAlertSetting = useAppSelector(
    state => state.tireAlertSetting.entity
  );

  const loading = useAppSelector(
    state => state.tireAlertSetting.loading
  );

  const [selectedValue, setSelectedValue] =
    useState<TireAlertSettingWithError>({
      error: null,
    });

  useEffect(() => {
    dispatch(getEntities());
  }, [dispatch]);

  useEffect(() => {
    if (tireAlertSetting?.id) {
      setSelectedValue({
        ...tireAlertSetting,
        error: null,
      });
    }
  }, [tireAlertSetting]);

  const handleChange = (
    field: 'grooveOdometer' | 'rotationOdometer',
    raw: string
  ) => {
    if (!/^\d*$/.test(raw)) {
      return;
    }

    setSelectedValue(prev => ({
      ...prev,
      [field]: raw === '' ? null : Number(raw),
    }));
  };

  const handleSubmit = async () => {
    if (selectedValue.error) {
      return;
    }

    await dispatch(
      updateEntity({
        id: selectedValue.id,
        grooveOdometer: selectedValue.grooveOdometer,
        rotationOdometer: selectedValue.rotationOdometer,
      })
    );
  };

  const handleRestoreDefault = async () => {
    await dispatch(restoreDefault());
  };

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 4,
        minHeight: '85vh',
        backgroundColor: theme.palette.background.default,
      }}
    >
      <CardContent
        sx={{
          p: 4,
        }}
      >
        {/* HEADER */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.secondary,
            mb: 4,
          }}
        >
          <Translate contentKey="fleetSenseApp.tireAlertSetting.home.title">
            Tire Alert Settings
          </Translate>
        </Typography>
        {/* INNER CARDS */}
        <Grid container spacing={3}>
          {/* GROOVE */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                height: '100%',
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: '1.3rem',
                  }}
                >
                <Translate contentKey="fleetSenseApp.tireAlertSetting.grooveOdometer"></Translate>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{
                      ml: 1,
                      color: 'text.secondary',
                    }}
                  >
                    (km)
                  </Typography>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    minHeight: 70,
                    mt: 1,
                    mb: 2,
                    fontSize: '1rem',
                  }}
                >
                <Translate contentKey="fleetSenseApp.tireAlertSetting.grooveOdometerMessage"></Translate>
                </Typography>
                <TextField
                  type="text"
                  inputProps={{
                    inputMode: 'numeric',
                  }}
                  size="small"
                  fullWidth
                  value={selectedValue.grooveOdometer ?? ''}
                  onChange={e =>
                    handleChange(
                      'grooveOdometer',
                      e.target.value
                    )
                  }
                  error={!!selectedValue.error}
                  helperText={
                    selectedValue.error
                      ? selectedValue.error
                      : ' '
                  }
                />
              </CardContent>
            </Card>
          </Grid>
          {/* ROTATION */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: 3,
                height: '100%',
                backgroundColor: theme.palette.background.paper,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 0.5,
                    fontSize: '1.3rem',
                  }}
                >
                <Translate contentKey="fleetSenseApp.tireAlertSetting.rotationOdometer"></Translate>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{
                      ml: 1,
                      color: 'text.secondary',
                    }}
                  >
                    (km)
                  </Typography>
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    minHeight: 70,
                    mt: 1,
                    mb: 2,
                    fontSize: '1rem',
                  }}
                >
                <Translate contentKey="fleetSenseApp.tireAlertSetting.rotationOdometerMessage"></Translate>
                </Typography>
                <TextField
                  type="text"
                  inputProps={{
                    inputMode: 'numeric',
                  }}
                  size="small"
                  fullWidth
                  value={selectedValue.rotationOdometer ?? ''}
                  onChange={e =>
                    handleChange(
                      'rotationOdometer',
                      e.target.value
                    )
                  }
                  error={!!selectedValue.error}
                  helperText={
                    selectedValue.error
                      ? selectedValue.error
                      : ' '
                  }
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* BUTTONS */}
        <Box
          sx={{
            mt: 4,
          }}
        >
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={2}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleRestoreDefault}
              disabled={loading}
            >
              Restaurar padrão
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={loading || !!selectedValue.error}
            >
              <Translate contentKey="entity.action.save">
                Save
              </Translate>
            </Button>
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TireAlertSetting;